/**
 * Relationship type utility constants for the WeTree Web UI
 *
 * Note: The actual RelationshipType is imported from we-tree-api-client
 */

import { RelationshipType as RelationshipTypeObject, RelationshipType } from 'we-tree-api-client/v2';

// Extract values from the API client's RelationshipType object to ensure we stay in sync
export const RELATIONSHIP_TYPE_VALUES: readonly RelationshipType[] = Object.values(RelationshipTypeObject);

// Re-export the type for convenience
export type { RelationshipType };
